import * as S from './styled';

interface Props {
  minRows: number
  autoSize: boolean
}

const Textarea = ({ minRows = 2, autoSize = true, ...props }: Props) => autoSize ? (
  <S.AutoSizeTextarea
    minRows={minRows}
    {...props}
  />
) : (
  <S.BaseTextarea
    minRows={minRows}
    {...props}
  />
)

export default Textarea
